import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — resets window scroll to (0, 0) on every route change.
 * Renders nothing. Must be a descendant of <BrowserRouter>.
 */
export default function ScrollToTop() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        // "instant" avoids the jarring smooth-scroll animation between pages.
        // The Estimate flow can still opt into smooth scroll within a page.
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname, search]);
    return null;
}
